/** Static app settings that can't be customized by users. */
export const CONSTANTS = {
  randomGraph: {
    latLngMax: 10,
    connectionsMin: 1,
    connectionsMax: 3,
  },
  baseSleepDuration: 800,
};
